import React from 'react'
import newsly from './newsly.png';

export default function Navbar() {
    
  return (
    <nav>
        <img src={newsly} alt='newsly' width='150px'/>
    </nav>
  )
}
